import React from "react";
import { createRoot } from "react-dom/client";
import html2pdf from "html2pdf.js";
import header from "../assets/img/header.jpg";
import { serverFormRequest } from "../util/server_request";
import { getCompanyHeaderInfo } from "../util/config";


const TRANSACTIONS_PER_PAGE = 20; // Keep for future use if needed

const StatementHeader = ({ data }) => {
  const companyInfo = getCompanyHeaderInfo();
  
  return (
    <div style={{ 
      marginBottom: "8mm",
      pageBreakInside: "avoid",
      width: "100%"
    }}>
      <div style={{ 
        textAlign: "center", 
        marginBottom: "8mm"
      }}>
        <img 
          src={header} 
          alt="Header" 
          style={{ 
            width: "100%",
            maxWidth: "180mm",
            maxHeight: "15mm",
            height: "auto",
            objectFit: "contain",
            marginBottom: "3mm" 
          }} 
        />
      </div>

      <div style={{ 
        textAlign: "left", 
        marginBottom: "8mm", 
        lineHeight: "1.4",
        fontSize: "11px",
        fontFamily: '"Times New Roman", Times, serif'
      }}>
        <strong style={{ fontSize: "14px" }}>
          {companyInfo.name}
        </strong><br />
        {companyInfo.address}<br />
        {companyInfo.contact}
      </div>

      <div style={{ 
        textAlign: "left", 
        marginBottom: "8mm",
        borderBottom: "1px solid #ccc",
        paddingBottom: "3mm",
        paddingLeft: "5mm",
        background: "linear-gradient(to left, #69db7c, #0b6623)",
        color: "white",
        pageBreakInside: "avoid"
      }}>
        <strong style={{ textTransform: "uppercase", fontSize: "14px" }}>
          {data.schemeName || ""}
        </strong>
      </div>   <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "8mm",
    paddingBottom: "3mm",
    borderBottom: "1px solid #eee",
    fontSize: "11px",
    fontFamily: '"Times New Roman", Times, serif',
    textTransform: "uppercase",
    pageBreakInside: "avoid"
  }}
>
  {/* Left Side: Period + Customer Details */}
  <div style={{ flex: 1, textAlign: "left" }}>
    <div style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "3mm" }}>
      <span style={{ fontWeight: "bold" }}>Period:</span> {data.year || "N/A"}
    </div>
    <div style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "3mm" }}>
      Customer Details
    </div>
    <div style={{ marginBottom: "1mm" }}><span style={{ fontWeight: "bold" }}>NAME:</span> {data.memberName || "N/A"}</div>
    <div style={{ marginBottom: "1mm" }}><span style={{ fontWeight: "bold" }}>MEMBER NO:</span> {data.ghanaNumber || "N/A"}</div>
    <div style={{ marginBottom: "1mm" }}><span style={{ fontWeight: "bold" }}>SSNIT NO:</span> {data.ssnit || "N/A"}</div>
    <div style={{ marginBottom: "1mm" }}><span style={{ fontWeight: "bold" }}>DOB:</span> {data.dob || "N/A"}</div>
    <div style={{ marginBottom: "1mm" }}><span style={{ fontWeight: "bold" }}>DATE JOINED:</span> {data.dateJoined || "N/A"}</div>
    <div style={{ marginBottom: "1mm" }}><span style={{ fontWeight: "bold" }}>RETIREMENT DATE:</span> {data.retirementDate || "N/A"}</div>
  </div>

  {/* Right Side: Employer Details */}
  <div style={{ flex: 1, textAlign: "left", paddingLeft: "5mm" }}>
    <div style={{ fontSize: "14px", fontWeight: "bold", marginBottom: "3mm" }}>
      Employer Details
    </div>
    <div style={{ marginBottom: "1mm" }}><span style={{ fontWeight: "bold" }}>EMPLOYER:</span> {data.employerName || "N/A"}</div>
    <div style={{ marginBottom: "1mm" }}><span style={{ fontWeight: "bold" }}>ERN:</span> {data.employerNumber || "N/A"}</div>
  </div>
</div>
</div>
);
}

const TransactionsTable = ({ transactions, showHeader = true, showTableHeader = true }) => (
  <div style={{ 
    width: "100%", 
    marginBottom: "10px", 
    paddingRight: "24px", 
    overflowX: "auto"
  }}>
    <table style={{ 
      width: "100%", 
      fontSize: "12px",
      fontFamily: '"Times New Roman", Times, serif'
    }}>
      {showTableHeader && (
        <thead>
          <tr style={{ background: "linear-gradient(to left, #69db7c, #0b6623)" }}>
            <th style={{ 
              padding: "8px 4px", 
              textAlign: "left", 
              color: "#fff",
              width: "20%"
            }}>
              TRANSACTION DATE
            </th>
            <th style={{ 
              padding: "8px 16px 8px 24px", // Extra left padding
              textAlign: "left", 
              color: "#fff",
              width: "50%"
            }}>
              DETAILS
            </th>
            <th style={{ 
              padding: "8px 6px", 
              textAlign: "right", 
              color: "#fff",
              width: "30%"
            }}>
              AMOUNT
            </th>
          </tr>
        </thead>
      )}
      <tbody>
        {transactions && transactions.length > 0 ? (
          transactions.map((tx, idx) => (
            <tr key={idx} style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
              <td style={{ 
                padding: "6px 4px", 
                textAlign: "left",
                wordBreak: "break-word"
              }}>
                {tx.date}
              </td>
              <td style={{ 
                padding: "6px 16px 6px 24px", // Match header padding
                textAlign: "left",
                wordBreak: "break-word"
              }}>
                {tx.details}
              </td>
              <td style={{ 
                padding: "6px 6px", 
                textAlign: "right",
                wordBreak: "break-word"
              }}>
                {tx.amount}
              </td>
            </tr>
          ))
        ) : (
          <tr style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
            <td colSpan="3" style={{ 
              textAlign: "center", 
              padding: "20px",
              fontStyle: "italic",
              color: "#666"
            }}>
              No transactions for this period
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
);

const FinancialSummary = ({ data }) => (
<div
  style={{
    textAlign: "right", // keep text right-aligned
    maxWidth: "95%",
    marginRight: "0", // pull the div more to the left
    paddingRight: "2px", // reduce padding
    whiteSpace: "normal",
    wordBreak: "break-word",
    pageBreakInside: "avoid",
    breakInside: "avoid"
  }}
>
  <div
    style={{
      marginTop: "15px",
      borderRadius: "5px",
      padding: "20px",
      overflowX: "auto",
      pageBreakInside: "avoid",
      breakInside: "avoid"
    }}
  >
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "auto auto", // two columns
        columnGap: "20px", // reduce gap between label and value
        rowGap: "6px",
        marginBottom: "10px",
        fontSize: "14px",
        fontWeight: "normal",
        fontFamily: '"Times New Roman", Times, serif',
        pageBreakInside: "avoid",
        breakInside: "avoid"
      }}
    >
      <div style={{ fontWeight: "bold", paddingLeft: "0" }}>Total Contribution:</div>
      <div style={{ textAlign: "right" }}>{data.totalContribution}</div>

      <div style={{ fontWeight: "bold", paddingLeft: "0" }}>Transfer Received:</div>
      <div style={{ textAlign: "right" }}>{data.transferReceived}</div>

      <div style={{ fontWeight: "bold", paddingLeft: "0" }}>Total Redemption:</div>
      <div style={{ textAlign: "right" }}>{data.totalRedemption}</div>

      <div style={{ fontWeight: "bold", paddingLeft: "0" }}>Gain/Loss:</div>
      <div style={{ textAlign: "right" }}>{data.gainLoss}</div>

      <div style={{ fontWeight: "bold", fontSize: "14px", paddingLeft: "0" }}>Account Value:</div>
      <div
        style={{
          textAlign: "right",
          fontSize: "14px",
          fontWeight: "bold",
          borderTop: "1px solid #000",
          borderBottom: "1px solid #000",
          padding: "4px 0"
        }}
      >
        {data.accountValue}
      </div>

      <div style={{ fontWeight: "bold", paddingLeft: "0" }}>Total Units:</div>
      <div style={{ textAlign: "right" }}>{data.totalUnits}</div>

      <div style={{ fontWeight: "bold", paddingLeft: "0" }}>Current Price:</div>
      <div style={{ textAlign: "right" }}>{data.currentPrice}</div>
    </div>
  </div>
</div>
);


const StatementPage = ({ 
  data, 
  transactions, 
  showHeader, 
  showSummary, 
  showOpeningBalance, 
  pageNumber, 
  totalPages,
  isLastMemberPage
}) => {
  return (
    <div 
      data-member={data.memberName}
      data-page={pageNumber}
      data-total-pages={totalPages}
      style={{
        position: "relative",
        width: "210mm",
        minHeight: "0", // Remove forced full A4 height
        padding: "8mm 8mm 6mm 8mm", // Slightly reduced padding
        margin: "0 auto",
        fontFamily: '"Times New Roman", Times, serif',
        fontSize: "12px",
        lineHeight: "1.4",
        color: "#000",
        backgroundColor: "#fff",
        boxSizing: "border-box",
        pageBreakAfter: isLastMemberPage ? "auto" : "always",
        pageBreakInside: "avoid"
      }}>
      
      {/* Header Section */}
      {showHeader && (
        <div style={{ marginBottom: "15mm" }}>
          <StatementHeader data={data} />
        </div>
      )}

      {/* Opening Balance Section */}
      {showOpeningBalance && (
        <div style={{ marginBottom: "5mm" }}>
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "3mm",
            fontSize: "13px",
            fontWeight: "bold",
            padding: "4px 16px",
          }}>
            <div>UNITS BF: {data.unitsBF || '0.00'}</div>
            <div style={{ marginRight: "24px" }}>ACCOUNT VALUE BF: {data.accountValueBF || '0.00'}</div>
          </div>
          <hr style={{ border: "1px solid #000", margin: "0 0 5mm 0" }} />
        </div>
      )}

      {/* Transactions Section */}
      <div style={{ 
        marginBottom: showSummary ? "0" : "12mm",
        width: "100%",
        minHeight: "0"
      }}>
        <TransactionsTable 
          transactions={transactions} 
          showHeader={true}
          showTableHeader={true}
        />
        {/* Transaction count info */}
        <div style={{
          fontSize: "10px",
          color: "#666",
          textAlign: "left",
          marginTop: "5mm"
        }}>
          Total transactions: {transactions ? transactions.length : 0}
        </div>
      </div>

      {/* Summary Section */}
      {showSummary && (
        <div style={{ marginTop: "8mm", marginBottom: "8mm", pageBreakInside: "avoid", breakInside: "avoid" }}>
          <hr style={{ border: "1px solid #000", margin: "8mm 0" }} />
          <FinancialSummary data={data} />
        </div>
      )}
    </div>
  );
};

const MemberStatement = ({ memberData, isLastMember, memberIndex, totalMembers }) => {
  const transactions = memberData.transactions || [];
  
  
  // Since members have few transactions, create just one page per member - no pagination needed
  return (
    <StatementPage
      key={`member-${memberData.memberName}`}
      data={memberData}
      transactions={transactions}
      showHeader={true}
      showSummary={true}
      showOpeningBalance={true}
      pageNumber={memberIndex + 1} // Current member's page number
      totalPages={totalMembers} // Total number of pages/members
      isLastMemberPage={isLastMember}
    />
  );
};

const StatementOfAccountPDF = ({ data }) => {
  if (!data?.length) {
    return (
      <div style={{ 
        padding: "10mm",
        textAlign: "center",
        fontFamily: '"Times New Roman", Times, serif'
      }}>
        <h2>No Data Available</h2>
      </div>
    );
  }


  return (
    <div style={{
      width: "100%",
      fontFamily: '"Times New Roman", Times, serif'
    }}>
      {data.map((memberData, index) => {
        return (
          <MemberStatement 
            key={`member-${memberData.memberName}-${index}`}
            memberData={memberData}
            memberIndex={index} // Pass current member index
            totalMembers={data.length} // Pass total number of members
            isLastMember={index === data.length - 1}
          />
        );
      })}
    </div>
  );
};

const processApiResponse = (apiResponse) => {
  if (!apiResponse?.data) return [];
  
  // Handle array of members from the new nested API structure
  const responseData = Array.isArray(apiResponse.data) ? apiResponse.data : [apiResponse.data];
  
  // Helper to safely parse various date formats and return YYYY-MM-DD or 'N/A'
  const safeFormatDate = (dateVal) => {
    if (!dateVal && dateVal !== 0) return 'N/A';
    try {
      // If it's a number (timestamp), create date directly
      if (typeof dateVal === 'number') {
        const dnum = new Date(dateVal);
        if (!Number.isNaN(dnum.getTime())) return dnum.toISOString().split('T')[0];
      }

      const str = String(dateVal).trim();
      // Fast path: ISO-like with T
      let d = new Date(str);
      if (Number.isNaN(d.getTime())) {
        // Try replacing space with 'T' (common 'YYYY-MM-DD HH:mm:ss')
        d = new Date(str.replace(' ', 'T'));
      }
      if (Number.isNaN(d.getTime())) {
        // Try extracting YYYY-MM-DD if present
        const m = str.match(/(\d{4}-\d{2}-\d{2})/);
        if (m) return m[1];
        return 'N/A';
      }
      return d.toISOString().split('T')[0];
    } catch (err) {
      return 'N/A';
    }
  };

  return responseData.map((memberItem, index) => {
    // Extract nested data from the API structure
    const memberData = memberItem.memberData || {};
    const employerData = memberItem.employerData || {};
    const transactionData = memberItem.transactionData || {};
    const transactions = transactionData.transactions || [];
    
    // Process transactions from the API data
    const processedTransactions = transactions.map(tx => ({
      date: tx && tx.transactionDate ? safeFormatDate(tx.transactionDate) : 'N/A',
      details: tx && (tx.narration || tx.description) ? (tx.narration || tx.description) : 'Transaction',
      amount: (tx && (tx.amount || tx.amount === 0)) ? tx.amount : 0
    }));
    
    
    const processedMember = {
      schemeName: memberItem.schemeName || 'OLD MUTUAL ASPIRE PENSION SCHEME',
      memberName: memberData.memberName || `Member ${index + 1}`,
      ssnit: memberData.ssnit || 'N/A',
      ghanaNumber: memberData.ghanaNumber || 'N/A',
  dob: safeFormatDate(memberData.dob),
  dateJoined: safeFormatDate(memberData.dateJoined),
  retirementDate: safeFormatDate(memberData.retirementDate),
      employerName: employerData.employerName || 'N/A',
      employerNumber: employerData.employerNumber || 'N/A',
      year: memberItem.year || new Date().getFullYear(),
      unitsBF: memberData.unitsBF || '0.00',
      accountValueBF: transactionData.accountValueBF || 0,
      
      // Use actual transaction data from API
      transactions: processedTransactions,
      
      // Financial summary data from transactionData
      totalContribution: transactionData.totalContribution || 0,
      transferReceived: transactionData.transferReceived || 0,
      totalRedemption: transactionData.totalRedemption || 0,
      gainLoss: transactionData.gainLoss || 0,
      accountValue: transactionData.accountValue || 0,
      totalUnits: transactionData.totalUnits || 0,
      currentPrice: transactionData.currentPrice || 0,
      
      // Additional member info (not in nested structure)
      tin: 'N/A', // Not provided in the new API structure
      mobile_no: 'N/A', // Not provided in the new API structure
      email: 'N/A', // Not provided in the new API structure
      pension_type_name: 'N/A' // Not provided in the new API structure
    };
    
    const transactionCount = processedMember.transactions.length;
    const pagesNeeded = Math.max(1, Math.ceil(transactionCount / TRANSACTIONS_PER_PAGE));
    
    return processedMember;
  });
};

export const generateAndDownloadPDF = async (apiResponse, options = {}) => {
  const { autoSend = false, previewMode = false } = options;
  
  try {
    const processedData = processApiResponse(apiResponse);
    // Calculate total pages needed - one page per member now
    const totalPages = processedData.length;
    
    const container = document.createElement("div");
    container.style.position = "absolute";
    container.style.left = "-9999px";
    container.style.top = "-9999px";
    container.style.width = "210mm";
    container.style.height = "auto"; // Let container expand with content
    container.style.minHeight = `${processedData.length * 297}mm`; // Minimum height for all members
    container.style.backgroundColor = "#fff";
    container.style.fontFamily = '"Times New Roman", Times, serif';
    container.style.fontSize = "12px";
    container.style.lineHeight = "1.4";
    container.style.color = "#000";
    container.style.boxSizing = "border-box";
    container.style.overflow = "visible"; // Ensure all content is visible
    document.body.appendChild(container);

    const root = createRoot(container);

    const pdfBlob = await new Promise((resolve, reject) => {
      try {
        root.render(
          <div id="pdf-content">
            <StatementOfAccountPDF data={processedData} />
          </div>
        );

        setTimeout(async () => {
          try {
            const element = document.getElementById("pdf-content");
            if (!element) throw new Error("PDF content element not found");

            // Wait additional time for multi-member content to fully render
            await new Promise(resolve => setTimeout(resolve, 1000));

            // Verify all members are rendered
            const memberElements = element.querySelectorAll('[data-member]') || [];
            const pageElements = element.querySelectorAll('[data-page]') || [];
            // ...existing code...

            const opt = {
              margin: [5, 5, 5, 5],
              filename: `Statement_${new Date().toISOString().slice(0, 10)}.pdf`,
              image: { type: "jpeg", quality: 0.95 },
              html2canvas: { 
                scale: 1.2, // Reduced scale for better performance
                useCORS: true,
                allowTaint: true,
                backgroundColor: "#ffffff",
                logging: false,
                // Remove fixed dimensions to capture full content
                scrollX: 0,
                scrollY: 0,
                letterRendering: true
              },
              jsPDF: { 
                unit: "mm", 
                format: "a4", 
                orientation: "portrait",
                putOnlyUsedFonts: true,
                hotfixes: ["px_scaling"],
                compress: true
              },
              pagebreak: { 
                mode: ['css'],  // Only use CSS mode to respect our pageBreakAfter logic
                avoid: ['tr', '.avoid-break', 'table', 'thead', 'tfoot'],
                // Remove before/after classes that could cause extra breaks
              }
            };

            const result = await html2pdf()
              .from(element)
              .set(opt)
              .outputPdf('blob');
            
            resolve(result);
          } catch (error) {
            console.error('❌ PDF generation error:', error);
            reject(error);
          }
        }, 3000); // Increased timeout for multi-member rendering
      } catch (error) {
        console.error('Render error:', error);
        reject(error);
      }
    });

    // Clean up DOM
    setTimeout(() => {
      root.unmount();
      document.body.removeChild(container);
    }, 100);

    // Handle different modes
    if (previewMode) {
      // Return blob for modal preview
      return pdfBlob;
    } else {
      // Auto-download behavior
      const url = URL.createObjectURL(pdfBlob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Statement_${new Date().toISOString().slice(0, 10)}.pdf`;
      document.body.appendChild(a);
      a.click();
      
      setTimeout(() => {
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      }, 100);
    }

    if (autoSend) {
      await sendPdfToServer(pdfBlob, options);
    }

    return pdfBlob;

  } catch (error) {
    console.error('PDF generation failed:', error);
    throw error;
  }
};

const sendPdfToServer = async (pdfBlob, metadata = {}) => {
  try {
    const formData = new FormData();
    formData.append("statement", pdfBlob, `Statement_${new Date().toISOString().slice(0, 10)}.pdf`);
    formData.append("statement-type", "EMPLOYEE_STATEMENT");
    formData.append("metadata", JSON.stringify(metadata));

    const res = await serverFormRequest("POST", "statements/send", formData);
    
    if (!res?.success) {
      throw new Error(res?.message || "Failed to send PDF");
    }
    
    return res;
  } catch (err) {
    console.error("Error sending PDF:", err);
    throw err;
  }
};

export const useMemberStatementReportPDF = () => {
  const generateAndSend = async (apiResponse, options = {}) => {
    try {
      return await generateAndDownloadPDF(apiResponse, options);
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  };

  const generateForPreview = async (apiResponse, options = {}) => {
    try {
      return await generateAndDownloadPDF(apiResponse, { ...options, previewMode: true });
    } catch (error) {
      console.error('Error generating PDF for preview:', error);
      throw error;
    }
  };

  const generateForDownload = async (apiResponse, options = {}) => {
    try {
      return await generateAndDownloadPDF(apiResponse, { ...options, previewMode: false });
    } catch (error) {
      console.error('Error generating PDF for download:', error);
      throw error;
    }
  };

  return {
    generateAndDownloadPDF,
    generateAndSend,
    generateForPreview,
    generateForDownload,
    sendPdfToServer
  };
};

export default generateAndDownloadPDF;
